import React from 'react';
import { FaRegStar, FaStar } from 'react-icons/fa';
import { useT } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/FavoriteButton.css';

/**
 * A song's favorite star (ENG-443, spec'd in ENG-264), on the listener song
 * list and in the stream page's crate.
 *
 * A toggle button: its name stays "Favorite <title>" and `aria-pressed`
 * carries the state, so a screen reader hears "pressed" / "not pressed".
 * The state is not shown by colour alone either: a favorite is a filled star,
 * any other song an outlined one, and the tooltip says which action a click
 * takes.
 *
 * The click does not bubble, so a star on a card or tile never also opens
 * the song.
 */
const FavoriteButton = ({ title, favorited, busy = false, onToggle, className = '', testId }) => {
  const t = useT();
  return (
    <button
      type="button"
      className={`favorite-button${favorited ? ' favorite-button--on' : ''}${className ? ` ${className}` : ''}`}
      aria-pressed={favorited}
      aria-label={t('favorites.toggle', { title })}
      title={t(favorited ? 'favorites.remove' : 'favorites.add')}
      aria-busy={busy || undefined}
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggle();
      }}
    >
      {favorited ? <FaStar aria-hidden="true" /> : <FaRegStar aria-hidden="true" />}
    </button>
  );
};

export default FavoriteButton;
